import React, { useState, useRef, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';

import { TablaResultados } from './TablaResultados';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioFormatos } from '../../../servicios/ServicioFormatos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR, DEFAULT_MASKS } from '../../../servicios/Constantes';
const PAGINACION_INICIAL = {
    registrosPorPagina: 20,
    numeroPagina: 0,
    restriccionesDinamicas: [],
    datos: [],
    join: {}
};

export const ConsultaRecibos = () => {

    const [busqueda, setBusqueda] = useState({});
    const [usuario, setUsuario] = useState({});
    const [errores, setErrores] = useState({});
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    const toast = useRef(null);

    useEffect(() => {
        // declare the data fetching function
        consultarUsuarioSession();
        

    }, [])


    const handleChange = e => {
        const { name, value } = e.target;
        console.log(name);
        console.log(value);
        setBusqueda(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
        
    };
    const asignarRestricciones = () => {
        paginacion.restriccionesDinamicas = [];

       

        if (!ServicioObjetos.esObjetoVacio(busqueda.fechaInicial) && !ServicioObjetos.esObjetoVacio(busqueda.fechaFinal)) {
            let laFechaInicial = ServicioFormatos.formatearFechaString(busqueda.fechaInicial);
            let laFechaFinal = ServicioFormatos.formatearFechaString(busqueda.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'between',
                nombrePropiedad: 'fechaCreacion',
                valorPropiedad: null,
                fechaIncialBetween: laFechaInicial,
                fechaFinalBetween: laFechaFinal
            });
        }
        if(usuario.tcPerfil.id===2)
        if (!ServicioObjetos.esObjetoVacio(busqueda.rfcEmisor)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'rfcEmisor',
                valorPropiedad: usuario.usuario,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.rfc)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'rfcReceptor',
                valorPropiedad: busqueda.rfc,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.uuid)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'uuid',
                valorPropiedad: busqueda.uuid,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.total)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'total',
                valorPropiedad: busqueda.total,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }

       
        paginacion.join = { "ttUsuario": "alias_ttUsuario","ttLayout":"alias_ttLayout" };

        setPaginacion(paginacion);
    }

    const funcionPaginacion = (laPaginacion) => {
        setPaginacion(laPaginacion);
        paginar();
    }

    const consultarUsuarioSession=()=>{
        ServicioHttp.consumirPostHttp('usuario/obtner.json').then(response => {
          setUsuario(response.data.objeto);
        }).catch(error => {
            console.log(error);
        });
    }

    const paginar = () => {
        asignarRestricciones();
        ServicioHttp.consumirPostHttp('consulta/recibos_nomina.json', paginacion).then(response => {
            setPaginacion(response.data.objeto);
            toast.current.show({ severity: response.data.error === false ? "success" : "error", summary: '', detail: response.data.mensaje, life: 8000 });
        }).catch(error => {
            setPaginacion(paginacion);
            toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
        });
    }

    const buscar = () => {
        paginacion.numeroPagina = 0;
            paginar();
        
    }

    return (
        <div>
             <Toast ref={toast} />
             <div className="grid">
             <div className="col-12">
             <div className="card">
                        <h5>Búsqueda de recibos de nómina</h5>
                        <p>En esta sección usted podrá consultar todos los Cfdi que ha timbrado en el portal</p>
                    </div>
                    <div className="card">
                        <h5>Para realizar la búsqueda elije uno o varios criterios</h5>
                        
                        <div className="p-fluid formgrid grid">
                        <div className="field col-12 md:col-6">
                                <label htmlFor="uuid">Folio Fiscal:</label>
                                <InputText id="uuid" type="text" name="uuid"
                                    value={busqueda.uuid || ""} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="rfc">RFC Empleado:</label>
                                <InputText id="rfc" type="text" name="rfc"
                                    value={busqueda.rfc || ""} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="fechaInicial">Fecha Emisión Inicial:</label>
                                <Calendar dateFormat={FORMATO_FECHA_CALENDAR} appendTo={document.body}
                                    id="fechaInicial" showIcon name="fechaInicial"
                                    value={busqueda.fechaInicial || ""} onChange={handleChange} className={errores.fechaInicial ? "p-invalid" : ""} />
                                {errores.fechaInicial ? <div><Message severity="error" text={errores.fechaInicial} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="zip">Fecha Emisión Final:</label>
                                <Calendar dateFormat={FORMATO_FECHA_CALENDAR} appendTo={document.body}
                                    id="fechaFinal" showIcon name="fechaFinal"
                                    value={busqueda.fechaFinal || ""} onChange={handleChange} className={errores.fechaFinal ? "p-invalid" : ""} />
                                {errores.fechaFinal ? <div><Message severity="error" text={errores.fechaFinal} /></div> : null}
                            </div>
                            <div className="col-12 md:col-3">
                                <Button label="Buscar" icon="pi pi-search" onClick={buscar} />
                            </div>
                            </div>
                        </div>
                 </div>
             </div>
             <TablaResultados paginacion={paginacion} funcionPaginacion={funcionPaginacion} toast={toast} asignarRestricciones={asignarRestricciones} />
            </div>
        );
}
